import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, ReferenceLine } from 'recharts';
import { useMarginalFeatureValues } from '../../hooks/useCalculations';
import { formatCurrencyCompact } from '../../lib/formatters';
import { GRID_PROPS, Y_AXIS_PROPS, TOOLTIP_STYLE, CHART_COLORS } from '../../styles/chart-theme';
import { InfoButton } from '../common/Tooltip';
import { useIsMobile } from '../../hooks/useIsMobile';

export function MarginalValueChart() {
  const isMobile = useIsMobile();
  const marginals = useMarginalFeatureValues(0);
  const data = marginals.map(m => ({ name: m.name, value: Math.round(m.marginalPnL), isEnabled: m.isEnabled }));

  return (
    <div className="card">
      <div className="flex items-center gap-2 mb-1">
        <h3 className="text-heading font-semibold text-secondary uppercase tracking-wider">Incremental Profit Impact</h3>
        <InfoButton helpKey="marginalValue" size={13} />
      </div>
      <p className="text-sm text-muted mb-4">Scenario P&L impact of toggling each feature in Package A's current bundle</p>
      <ResponsiveContainer width="100%" height={isMobile ? 220 : 300}>
        <BarChart data={data} layout="vertical" margin={{ top: 5, right: 40, left: 140, bottom: 5 }}>
          <CartesianGrid {...GRID_PROPS} horizontal={false} vertical />
          <XAxis type="number" tick={{ fill: 'var(--color-axis-tick)', fontSize: 12 }} tickFormatter={v => formatCurrencyCompact(v)} />
          <YAxis type="category" dataKey="name" {...Y_AXIS_PROPS} width={130} tick={{ fill: 'var(--color-text-primary)', fontSize: 12 }} />
          <Tooltip {...TOOLTIP_STYLE} formatter={(value: number, _name: string, props: any) => { const label = props.payload.isEnabled ? 'Value of keeping' : 'Value of adding'; return [formatCurrencyCompact(value), label]; }} />
          <ReferenceLine x={0} stroke="var(--color-reference-line)" />
          <Bar dataKey="value" radius={[0, 4, 4, 0]} maxBarSize={22}>
            {data.map((entry, i) => <Cell key={i} fill={entry.value >= 0 ? CHART_COLORS.emerald : CHART_COLORS.red} fillOpacity={entry.isEnabled ? 0.9 : 0.5} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="flex gap-4 mt-3 text-xs text-muted">
        <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-emerald-500/90" /> Currently enabled</span>
        <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-emerald-500/50" /> Not enabled (adding would...)</span>
      </div>
    </div>
  );
}
